import { render, staticRenderFns } from "./Char2.vue?vue&type=template&id=69536f31&"
import script from "./Char2.vue?vue&type=script&lang=js&"
export * from "./Char2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports